<template>
  <CModal
    v-model:visible="showModal"
    centered
    title="Filters"
    @close="closeModal"
  >
    <!--    <CSelect multiple v-model="filters.roles" :options="dataForSelect(roles)" label="Roles"></CSelect>-->
    <template v-if="!data_loading">
      <CSelect
        v-if="showStatus"
        v-model="filters.status"
        :options="statuses"
        label="Status"
      />
      <div class="mb-3">
        <label>Instructor</label>
        <multi-select
          :options="dataForSelect(data_filters.instructors)"
          :selected="filters.instructor"
          :selection="true"
          options-empty-placeholder="No options placeholder"
          search-placeholder="Search"
          selection-type="tags"
          :search="true"
          @update="updateData($event, 'instructor')"
        />
      </div>
      <div class="mb-3">
        <label>Language</label>
        <multi-select
          :search="true"
          :options="dataForSelect(data_filters.languages)"
          :selected="filters.language"
          :selection="true"
          options-empty-placeholder="No options placeholder"
          search-placeholder="Search"
          selection-type="tags"
          @update="updateData($event, 'language')"
        />
      </div>
      <div class="mb-3">
        <label>Class Type</label>
        <multi-select
          :search="true"
          :options="dataForSelect(data_filters.class_types)"
          :selected="filters.class_type"
          :selection="true"
          options-empty-placeholder="No options placeholder"
          search-placeholder="Search"
          selection-type="tags"
          @update="updateData($event, 'class_type')"
        />
      </div>
      <div class="mb-3">
        <label>Categories</label>
        <multi-select
          :search="true"
          :options="dataForSelect(data_filters.categories)"
          :selected="filters.category"
          :selection="true"
          options-empty-placeholder="No options placeholder"
          search-placeholder="Search"
          selection-type="tags"
          @update="updateData($event, 'category')"
        />
      </div>
      <div class="mb-3">
        <label>Tags</label>
        <multi-select
          :search="true"
          :options="dataForSelect(data_filters.tags)"
          :selected="filters.tag"
          :selection="true"
          options-empty-placeholder="No options placeholder"
          search-placeholder="Search"
          selection-type="tags"
          @update="updateData($event, 'tag')"
        />
      </div>
      <div
        v-if="showLength"
        class="mb-3"
      >
        <label>Length</label>
        <multi-select
          :search="true"
          :options="dataForSelect(data_filters.length)"
          :selected="filters.length"
          :selection="true"
          options-empty-placeholder="No options placeholder"
          search-placeholder="Search"
          selection-type="tags"
          @update="updateData($event, 'length')"
        />
      </div>
    </template>
    <template #footer-wrapper>
      <div class="d-flex my-3 align-items-center justify-content-center">
        <CButton
          color="primary"
          class="mx-auto"
          @click="apply"
        >
          Apply
        </CButton>
      </div>
    </template>
  </CModal>
</template>

<script>
import MultiSelect from "@/components/MultiSelect";
import { useAppStore } from '@/store';
export default {
  name: "FiltersModal",
  components: {MultiSelect},
  props: {
    showStatus: {
      type: Boolean,
      default: true
    },
    showLength: {
      type: Boolean,
      default: false
    }
  },
  setup() {
    const appStore = useAppStore();
    return { appStore };
  },
  data() {
    return {
      filters: {
        search: '',
        instructor: [],
        class_type: [],
        language: [],
        tag: [],
        category: [],
        length: [],
        status: null,
      },
      data_filters: {
        instructors: [],
        languages: [],
        tags: [],
        categories: [],
        class_types: [],
        length: [],
      },
      statuses: [
        {
          value: null,
          label: 'All'
        },
        {
          value: 'released',
          label: 'Released'
        },
        {
          value: 'draft',
          label: 'Draft'
        },
        {
          value: 'ready',
          label: 'Ready'
        },
        {
          value: 'filmed',
          label: 'Filmed'
        },
      ],
      showModal: false,
      step: 1,
      finished: false,
      data_loading: true,
    }
  },
  methods: {
    open(filters) {
      document.querySelector('body').classList.add('modal_open')
      this.showModal = true;
      Object.assign(this.filters, filters);
      if(this.data_loading) this.getData();
    },
    closeModal() {
      this.$emit('modal:close');
      document.querySelector('body').classList.remove('modal_open')
    },
    apply() {
      this.showModal = false;
      this.$emit('apply', this.filters);
      document.querySelector('body').classList.remove('modal_open')
    },
    getData() {
      this.$http.get('/sessions/data').then(({data}) => {
        this.data_filters = data;
        this.appStore.set('classesFilterData', data);
      }).finally(() => {
        this.data_loading = false;
      })
    },
    updateData(data, model) {
      this.filters[model] = data;
    },
    dataForSelect(data) {
      return data.map(item => {
        return {
          value: item.id,
          text: item.name
        }
      })
    },
  },
}
</script>

<style scoped>
</style>